
      const ep = import.meta.env?.VITE_ANALYTICS_ENDPOINT;
      const wid = import.meta.env?.VITE_ANALYTICS_WEBSITE_ID;
      if (ep && wid) {
        const s = document.createElement("script");
        s.defer = true;
        s.src = `${ep}/umami`;
        s.dataset.websiteId = wid;
        document.head.appendChild(s);
      }
    